import { render, staticRenderFns } from "./ConventionHeader.vue?vue&type=template&id=46829389&scoped=true"
import script from "./ConventionHeader.vue?vue&type=script&lang=js"
export * from "./ConventionHeader.vue?vue&type=script&lang=js"
import style0 from "./ConventionHeader.vue?vue&type=style&index=0&id=46829389&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46829389",
  null
  
)

export default component.exports